import {createAction, handleActions} from 'redux-actions';
import * as api from '../services/api';
import _ from 'lodash';
import { actions as labelCollection} from './labelCollection';

// regular actions
const SET = '@translationtool/projects/SET';
const SELECT = '@translationtool/projects/SELECT';
const RESET_SELECTED = '@translationtool/projects/RESET_SELECTED';
const REMOVE = '@translationtool/projects/REMOVE';
const ENABLE_PROJECT_FILTER = '@translationtool/projects/ENABLE_PROJECT_FILTER'
const DISABLE_PROJECT_FILTER = '@translationtool/projects/DISABLE_PROJECT_FILTER'

const set  = createAction(SET, projects => projects);
const select  = createAction(SELECT, project => project);
const resetSelected  = createAction(RESET_SELECTED);
const remove  = createAction(REMOVE, project => project);
const enableProjectFilter = createAction(ENABLE_PROJECT_FILTER)
const disableProjectFilter = createAction(DISABLE_PROJECT_FILTER)

export const reducer = handleActions(
	{
		[SET]: (state, action) => {
			return {...state, projects: action.payload};
		},
		[SELECT]: (state, action) => {
			return {...state, selected: action.payload};
		},
		[RESET_SELECTED]: (state) => {
			return {...state, selected: null};
		},
		[REMOVE]: (state, action) => {
			return {...state, projects: _.without(state.projects, _.find(state.projects, {name: action.payload.name}))};
		},
        [ENABLE_PROJECT_FILTER]: (state) => {
			return {...state, hasProjectFilter: true};
		},
        [DISABLE_PROJECT_FILTER]: (state) => {
			return {...state, hasProjectFilter: false};
		}
	},
	{
		projects: [],
		selected: null,
        hasProjectFilter: false,
	}
);

// thunks
const selectWrapper = (name) => (dispatch,) => {
	return api.handleFetch(
		() => api.fetchProject(name),
		dispatch,
		project => dispatch(select(project)),
		'Could not fetch project "' + name + '"'
	);
};

const fetch = () => (dispatch) => {
	return api.handleFetch(
		() => api.fetchProjects(),
		dispatch,
		projects => dispatch(set(projects)),
		'No projects found'
	);
};

const create = (project) => (dispatch) => {
	return api.handleUpdate(
		() => api.createProject(project),
		dispatch,
		() => dispatch(fetch())
	);
};

const update = (project) => (dispatch, getState) => {
	const name = encodeURIComponent(getState().project.selected.name);
	return api.handleUpdate(
		() => api.updateProject(name, project),
		dispatch,
		() => {
			dispatch(fetch());
			dispatch(selectWrapper(name))
		}
	);
};

const replace = (oldLanguage, newLanguage) => (dispatch, getState) => {
	const name = encodeURIComponent(getState().project.selected.name);
	return api.handleUpdate(
		() => api.replaceDefaultLanguageInAllCollections(
			name,
			oldLanguage,
			newLanguage
		),
		dispatch,
		() => {
			dispatch(selectWrapper(name))
		}
	);
};

const scan = (projectToScan) => (dispatch, getState) => {
	const name = encodeURIComponent(getState().project.selected.name);
	return api.handleUpdate(
		() => api.scanProject(projectToScan),
		dispatch,
		() => {
			dispatch(fetch());
			dispatch(selectWrapper(name))
		}
	)
};

const deleteProject = (project) => (dispatch) => {
	return api.handleUpdate(
		() => api.deleteProject(encodeURIComponent(project.name)),
		dispatch,
		() => dispatch(remove(project))
	);
};

const importProject = project => dispatch => {
	return api.handleUpdate(
		() => api.importProject(encodeURIComponent(project.name)),
		dispatch
	)
};

const renderProject = project => dispatch => {
	return api.handleUpdate(
		() => api.renderProject(encodeURIComponent(project.name)),
		dispatch
	)
};

const finishLanguages = (language, lCollection) => (dispatch, getState) => {
	const name = encodeURIComponent(getState().project.selected.name);
	return api.handleUpdate(
		() => api.finishLanguage(name, encodeURIComponent(lCollection.identifier), language),
		dispatch,
		() => {
			dispatch(fetch());
			dispatch(labelCollection.fetch())
			dispatch(selectWrapper(name))
		}
	)
};

// public actions
export const actions = {
	fetch,
	create,
	update,
	replace,
	scan,
	delete: deleteProject,
	select: selectWrapper,
	resetSelected,
	import: importProject,
	render: renderProject,
	finishLanguages,
    enableProjectFilter,
    disableProjectFilter
};



// WEBPACK FOOTER //
// ./React/src/reducers/project.js